import React from 'react';

import { useBudgetSpendingsQuery } from 'src/core/modules/budgets/budgets-by-dimensions/hooks/useBudgetSpendingsQuery';
import { type NodePath } from 'src/core/modules/budgets/budgets-by-dimensions/models/nodePath';
import { type PeriodInterval } from 'src/core/modules/budgets/models/periodInterval';

import { BreakdownSpendingsSectionWrapper } from './BreakdownSpendingSectionWrapper';
import { type BreakdownPart } from '../../../../models/breakdown';
import { type SpendingType } from '../../../../models/breakdownSpending';

type Props = {
  spendingType: SpendingType;
  budgetId: string;
  period: PeriodInterval;
  breakdownPart: BreakdownPart;
  nodePath: NodePath;
};

export const BreakdownSpendingsSectionV2 = ({
  spendingType,
  breakdownPart,
  budgetId,
  period,
  nodePath,
}: Props) => {
  const budgetBreakdownSpendingsQueryState = useBudgetSpendingsQuery({
    budgetDefinitionId: budgetId,
    breakdownPart,
    spendingType,
    period,
    nodePath,
  });
  return (
    <BreakdownSpendingsSectionWrapper
      queryState={budgetBreakdownSpendingsQueryState}
      spendingType={spendingType}
      breakdownPart={breakdownPart}
    />
  );
};
